import { useEffect } from "react";
import Header from "./components/header";
import Main from "./components/main";
import Footer from "./components/footer";
import ChatMeSDK from "./components/ChatMeScript";
import ScrollToTopButton from "../../components/ScrollToTopButton";
import CallBotSDK from "./components/CallBotScript";

const LandingPage = () => {

  return (
    <div className="flex flex-col w-full">
      <Header />
      <Main />
      <Footer />
      <ScrollToTopButton />
      <ChatMeSDK/>
      <CallBotSDK/>
    </div>
  );
};

export default LandingPage;
